import { SiteControlEvent } from '@scaleaq/sitecontrol-lib';

export function sortEvents(
  e1: SiteControlEvent,
  e2: SiteControlEvent,
  id: string,
  desc: boolean,
  getInventoryNameById: (sourceId: string) => string
): number {
  const compareValues = (v1: string, v2: string) =>
    desc ? v2.localeCompare(v1) : v1.localeCompare(v2);

  switch (id) {
    case 'timestamp': {
      const ts1 = new Date(e1.timestamp).getTime();
      const ts2 = new Date(e2.timestamp).getTime();
      return desc ? ts2 - ts1 : ts1 - ts2;
    }

    case 'sourcePath': {
      let val1 = getInventoryNameById(e1.inventoryId);
      let val2 = getInventoryNameById(e2.inventoryId);
      val1 = val1 === 'n/a' ? '' : val1;
      val2 = val2 === 'n/a' ? '' : val2;
      return compareValues(val1, val2);
    }

    case 'type': {
      const val1 = (e1.type || '').toString().trim();
      const val2 = (e2.type || '').toString().trim();
      return compareValues(val1, val2);
    }

    case 'sender': {
      const val1 = (e1.sender || '').toString().trim();
      const val2 = (e2.sender || '').toString().trim();
      return compareValues(val1, val2);
    }
    default: {
      const ts1 = new Date(e1.timestamp).getTime();
      const ts2 = new Date(e2.timestamp).getTime();
      return ts2 - ts1;
    }
  }
}
